// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2WKtF","noInteraction":"EventWrapper_noInteraction__xg2gU","pointerPassthrough":"EventWrapper_pointerPassthrough__2sTAZ"};